import React, { useState, useEffect } from 'react';
import { diffChars, diffWords, diffLines, diffTrimmedLines } from 'diff';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEraser, faCloudArrowUp } from '@fortawesome/free-solid-svg-icons';

const TextDiffChecker = () => {
  const [originalInput, setOriginalinput] = useState('');
  const [originalInput2, setOriginalinput2] = useState('');
  const [currentSetting, setCurrentSetting] = useState('diffChars');
  const settingOptions = [
    { key: 'diffChars', name: 'Chars' },
    { key: 'diffWords', name: 'Words' },
    { key: 'diffLines', name: 'Lines' },
    { key: 'diffTrimmedLines', name: 'Trimmed Lines' },
  ];

  const handleInputText = (event) => {
    setOriginalinput(event.target.value);
  };

  const handleInputText2 = (event) => {
    setOriginalinput2(event.target.value);
  };

  const getDiff = () => {
    let diff;
    switch (currentSetting) {
      case 'diffChars':
        diff = diffChars(originalInput, originalInput2);
        break;
      case 'diffWords':
        diff = diffWords(originalInput, originalInput2);
        break;
      case 'diffLines':
        diff = diffLines(originalInput, originalInput2);
        break;
      case 'diffTrimmedLines':
        diff = diffTrimmedLines(originalInput, originalInput2);
        break;
      default:
        diff = diffChars(originalInput, originalInput2);
        break;
    }

    let diffText = '';
    diff.forEach((part) => {
      const color = part.added ? 'green' : part.removed ? 'red' : 'grey';
      diffText += `<span style="color:${color}">${part.value}</span>`;
    });
    return diffText;
  };
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      const content = e.target.result;
      setOriginalinput(content);
    };
    reader.readAsText(file);
  };
  const handleFileUpload2 = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      const content = e.target.result;
      setOriginalinput2(content);
    };
    reader.readAsText(file);
  };


  return (
    <div>
      <div className="grid grid-cols-1 my-4 xl:grid-cols-2 xl:gap-4">
        <div className="p-4 mb-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:p-6 dark:border-gray-700 dark:bg-gray-800 xl:mb-0">
          <div className="px-4 py-2 font-medium text-md border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-blue-600 p-2'>original text</h3>
          </div>
          <div className="px-4 py-2 rounded">
            <textarea
              id="inputText"
              rows={10}
              className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Enter your original text here."
              value={originalInput}
              onChange={handleInputText}
            />
          </div>
          <div className="px-4 py-2">
            <input
              type="file"
              accept='.txt,.md,.html,.js,.css,.json,.yaml,.yml'
              onChange={handleFileUpload}
              className='hidden'
              name='file1'
            />
            <button
              onClick={() => document.querySelector('input[name="file1"]').click()}
              type="button"
              className="text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:ring-[#2557D6]/50 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-[#2557D6]/50 me-2 mb-2"
            >
              <FontAwesomeIcon icon={faCloudArrowUp}/>
              &nbsp; Browse your file
            </button>
            &nbsp;&nbsp;
            <button
              onClick={() => setOriginalinput('')}
              type="button"
              className="text-white bg-gray-400 hover:bg-gray-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              <FontAwesomeIcon icon={faEraser}/>
              &nbsp; Reset
            </button>
          </div>
        </div>
        <div className="p-4 mb-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:p-6 dark:border-gray-700 dark:bg-gray-800 xl:mb-0">
          <div className="px-4 py-2 font-medium text-md border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-yellow-600 p-2'>Changed text</h3>
          </div>
          <div className="px-4 py-2 rounded">
            <textarea
              id="inputText"
              rows={10}
              className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Enter your changes text here."
              value={originalInput2}
              onChange={handleInputText2}
            />
          </div>
          <div className="px-4 py-2">
            <input
              type="file"
              accept='.txt,.md,.html,.js,.css,.json,.yaml,.yml'
              onChange={handleFileUpload2}
              className='hidden'
              name='file2'
            />
            <button
              onClick={() => document.querySelector('input[name="file2"]').click()}
              type="button"
              className="text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:ring-[#2557D6]/50 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-[#2557D6]/50 me-2 mb-2"
            >
              <FontAwesomeIcon icon={faCloudArrowUp}/>
              &nbsp; Browse your file
            </button>
            &nbsp;&nbsp;
            <button
              onClick={() => setOriginalinput2('')}
              type="button"
              className="text-white bg-gray-400 hover:bg-gray-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              <FontAwesomeIcon icon={faEraser}/>
              &nbsp; Reset
            </button>
          </div>
        </div>
      </div>
      <div className="col-span-full xl:col-auto">
        <div className="p-4 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 rounded">
            <ul className="items-center w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg sm:flex dark:bg-gray-700 dark:border-gray-600 dark:text-white">
              <li class="w-full border-b border-gray-200 sm:border-b-0 sm:border-r dark:border-gray-600 pl-4">
                Diff Mode
              </li>
              {settingOptions.map((s, index) => {
                return (
                  <li class="w-full border-b border-gray-200 sm:border-b-0 sm:border-r dark:border-gray-600 pl-4">
                    <div class="flex items-center ps-3">
                      <input
                        id={`horizontal-list-radio-license-${index}`}
                        type="radio"
                        value={s.key}
                        name="list-radio"
                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                        onChange={(event) => setCurrentSetting(event.target.value)}
                        checked={currentSetting === s.key} // Add this line to set the default value
                      />
                      <label
                        for={`horizontal-list-radio-license-${index}`}
                        className="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300 ml-4"
                      >
                        {s.name}
                      </label>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="px-4 py-2 rounded">
            { originalInput && originalInput2 && (
              <div>
                <div className="px-4 py-2 font-medium text-md border border-gray-200 border-dashed rounded dark:border-gray-600">
                  <h3 className=''>Diff result</h3>
                </div>
                <div className='px-4 py-2' style={{overflow: 'auto' }} dangerouslySetInnerHTML={{ __html: getDiff() }}></div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* <div>
        <div className="grid grid-cols-2 gap-4 bg-white p-4 mt-4">
          <div>
            <input
              type="file"
              accept='.txt,.md,.html,.js,.css,.json,.yaml,.yml'
              onChange={handleFileUpload}
              className='hidden'
              name='file1'
            />
            <button
              className="mb-4 text-gray-500 border border-gray-700 hover:bg-gray-700 hover:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm p-2.5 text-center inline-flex items-center me-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:focus:ring-blue-800 dark:hover:bg-blue-500"
              onClick={() => setOriginalinput('')}
            >
              <FontAwesomeIcon
                style={{ width: '18px' }}
                icon={faEraser}
              />
            </button>
            <button
              className="mb-4 ml-4 text-gray-500 border border-gray-700 hover:bg-gray-700 hover:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm p-2.5 text-center inline-flex items-center me-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:focus:ring-blue-800 dark:hover:bg-blue-500"
              onClick={() => document.querySelector('input[name="file1"]').click()}
            >
              <FontAwesomeIcon
                style={{ width: '18px' }}
                icon={faUpload}
              />
            </button>
            <CodeEditor
              ref={textareaRef1}
              value={originalInput}
              onChange={handleInputText}
              placeholder="Enter your original text here."
              style={{
                fontSize: 13,
                backgroundColor: 'white',
                // height: pageHeight,
                border: '1px solid rgb(221, 221, 221)',
                overflow: 'auto',
              }}
              minHeight={pageHeight}
            />
          </div>
          <div>
            <input
              type="file"
              accept='.txt,.md,.html,.js,.css,.json,.yaml,.yml'
              onChange={handleFileUpload2}
              className='hidden'
              name='file2'
            />
            <button
              className="mb-4 text-gray-500 border border-gray-700 hover:bg-gray-700 hover:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm p-2.5 text-center inline-flex items-center me-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:focus:ring-blue-800 dark:hover:bg-blue-500"
              onClick={() => setOriginalinput2('')}
            >
              <FontAwesomeIcon
                style={{ width: '18px' }}
                icon={faEraser}
              />
            </button>
            <button
              className="mb-4 ml-4 text-gray-500 border border-gray-700 hover:bg-gray-700 hover:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm p-2.5 text-center inline-flex items-center me-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:focus:ring-blue-800 dark:hover:bg-blue-500"
              onClick={() => document.querySelector('input[name="file2"]').click()}
            >
              <FontAwesomeIcon
                style={{ width: '18px' }}
                icon={faUpload}
              />
            </button>
            <CodeEditor
              value={originalInput2}
              onChange={handleInputText2}
              placeholder="Enter your changes text here."
              style={{
                fontSize: 13,
                backgroundColor: 'white',
                // height: pageHeight,
                border: '1px solid rgb(221, 221, 221)',
                overflow: 'auto',
              }}
              minHeight={pageHeight}
            />
          </div>
        </div>
        <div className="grid gap-4 bg-white p-4">
          <h3 className="font-semibold text-gray-900 dark:text-white">Diff Mode</h3>
          <ul className="items-center w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg sm:flex dark:bg-gray-700 dark:border-gray-600 dark:text-white">
            {settingOptions.map((s, index) => {
              return (
                <li class="w-full border-b border-gray-200 sm:border-b-0 sm:border-r dark:border-gray-600 pl-4">
                  <div class="flex items-center ps-3">
                    <input
                      id={`horizontal-list-radio-license-${index}`}
                      type="radio"
                      value={s.key}
                      name="list-radio"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                      onChange={(event) => setCurrentSetting(event.target.value)}
                      checked={currentSetting === s.key} // Add this line to set the default value
                    />
                    <label
                      for={`horizontal-list-radio-license-${index}`}
                      className="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300 ml-4"
                    >
                      {s.name}
                    </label>
                  </div>
                </li>
              );
            })}
          </ul>
          { originalInput && originalInput2 && (<h3 className="font-semibold text-gray-900 dark:text-white">Diff Result</h3>)}
          <div style={{overflow: 'auto', minHeight: '35vh'}} dangerouslySetInnerHTML={{ __html: getDiff() }}></div>
        </div>
      </div> */}
    </div>
  );
};

export default TextDiffChecker;
